import React from 'react';

const Loading = () => <div className="Loading">Loading...</div>;

export default Loading;
